import { GridSelectionModel } from "@mui/x-data-grid";
import { IBatch, IBatchOpen } from "../models/batches";
import { IMaterialsPerSubActivity } from "../models/materials";
import { IStudentPerBatches } from "../models/students";

export const grupoBatches = (data: IBatchOpen[]): IBatch[] => {
    const groupedData: IBatch[] = data.reduce((acc: IBatch[], curr) => {
        const existingGroup = acc.find(group => group.activityCode === curr.activityCode && group.masterActivity === curr.masterActivity);

        if (existingGroup) {
            existingGroup.details.push({
                id: curr.id,
                batchDate: curr.batchDate,
                uniqueIdentifier: curr.uniqueIdentifier ?? ""
            });
        } else {
            acc.push({
                activityCode: curr.activityCode ?? "",
                masterActivity: curr.masterActivity ?? "",
                details: [{
                    id: curr.id,
                    batchDate: curr.batchDate,
                    uniqueIdentifier: curr.uniqueIdentifier ?? ""
                }]
            });
        }

        return acc;
    }, []);

    const renamedData = groupedData.map(group => ({
        ...group,
        details: group.details.map(detail => ({
            ...detail
        }))
    }));

    return renamedData;
};

export function calcQuantityMaterialsPerSubActivity(
    materialsPerSubActivity: IMaterialsPerSubActivity[],
    materialsPerSubActivityBase: IMaterialsPerSubActivity[],
    selectionModel: GridSelectionModel,
    studentsBatches: IStudentPerBatches[]
): IMaterialsPerSubActivity[] {
    const selectedRows = studentsBatches.filter((studentsBatches) => selectionModel.includes(studentsBatches.id));
    const groupedMaterials = groupMaterials(materialsPerSubActivity);

    let materialsResult: IMaterialsPerSubActivity[] = [];

    if (selectedRows.length <= 0) return materialsPerSubActivity;

    const selectedCount = selectedRows.length;
    let materialsConsumed: any = [];// total materials consumed
    for (const [key, materialList] of Object.entries(groupedMaterials)) {
        if (key.includes("material")) {
            const result = materialList.map(material => {
                const correspondingBaseItem = materialsPerSubActivityBase.find(baseItem => baseItem.id === material.id);
                if (correspondingBaseItem) {
                    const quantityToSubtract = correspondingBaseItem.quantity * selectedCount;
                    materialsConsumed.push({ id: material.id, quantity: quantityToSubtract })
                    return { ...material, availableQuantity: material.availableQuantity - quantityToSubtract };
                } else {
                    return material;
                }
            });
            materialsResult.push(...result);
            continue;
        }

        if (key.includes("courseId") && materialList.every(material => material.availableQuantity > 0)) {
            const result = materialList.map(material => {
                const correspondingBaseItem = materialsPerSubActivityBase.find(baseItem => baseItem.id === material.id);
                if (correspondingBaseItem) {
                    const quantityToSubtract = correspondingBaseItem.quantity * selectedCount;
                    materialsConsumed.push({ id: material.id, quantity: quantityToSubtract })
                    return { ...material, availableQuantity: material.availableQuantity - quantityToSubtract };
                } else {
                    return material;
                }
            });
            materialsResult.push(...result);
            continue;
        }

        if (key.includes("groupId")) {
            const result = materialList.map(material => {
                const selectedStudentCount = selectedRows.filter((student) =>
                ((material.topSizeId === student.topSizeId && !material.bottomSizeId) ||
                    (material.bottomSizeId === student.bottomSizeId && !material.topSizeId) ||
                    (!material.bottomSizeId && !material.topSizeId)))
                    .length;

                const correspondingBaseItem = materialsPerSubActivityBase.find(baseItem => baseItem.id === material.id);
                if (correspondingBaseItem) {
                    const quantityToSubtract = correspondingBaseItem.quantity * selectedStudentCount;
                    materialsConsumed.push({ id: material.id, quantity: quantityToSubtract })
                    return { ...material, availableQuantity: material.availableQuantity - quantityToSubtract };
                } else {
                    return material;
                }
            });
            materialsResult.push(...result);
        }
    }
    return materialsResult;
}
interface IGroupedMaterials {
    [key: string]: IMaterialsPerSubActivity[];
}

export function checkAvailability(student?: IStudentPerBatches, materialsList?: IMaterialsPerSubActivity[]): boolean {
    if (!student || !materialsList)
        return false;

    const groupedMaterials = groupMaterials(materialsList);

    let groupedMaterialsCount = 0;

    let materialsAvailable = 0;

    for (const [key, materialList] of Object.entries(groupedMaterials)) {

        groupedMaterialsCount++;
        if (key.includes("material") && materialList.every(material => material.availableQuantity > 0)) {
            materialsAvailable++;
        }

        if (key.includes("courseId") && materialList.every(material => material.availableQuantity > 0)) {
            materialsAvailable++;
        }

        if (key.includes("groupId")) {
            const group = materialList.find((material) =>
                (material.topSizeId === student.topSizeId && !material.bottomSizeId) ||
                (material.bottomSizeId === student.bottomSizeId && !material.topSizeId) ||
                (!material.bottomSizeId && !material.topSizeId)
            );
            if (group && group?.availableQuantity > 0)
                materialsAvailable++;
        }
    }

    return groupedMaterialsCount === materialsAvailable;
}
function groupMaterials(materialsList: IMaterialsPerSubActivity[]): IGroupedMaterials {
    return materialsList.reduce((acc: any, material) => {
        const key = !material.courseId && !material.groupId
            ? 'material'
            : material.courseId
                ? `courseId-${material.courseId}`
                : `groupId-${material.groupId}`;

        if (!acc[key]) {
            acc[key] = [];
        }

        acc[key].push(material);
        return acc;
    }, {});
}